module.exports = __webpack_public_path__ + "img/10-tyhjyys.18d970e9.jpg";